/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  add: {
    id: "b2b.smlouvy-grid.add",
    defaultMessage: "Add contract"
  },
  title: {
    id: "b2b.smlouvy-grid.title",
    defaultMessage: "Contracts"
  },
  deleteDialogTitle: {
    id: "b2b.smlouvy-grid.delete-dialog.title",
    defaultMessage: "Delete contract"
  },
  deleteDialogConfirm: {
    id: "b2b.smlouvy-grid.delete-dialog.confirm",
    defaultMessage: "Are you sure you want to delete the contract?"
  }
});

export default () => useMessages(MESSAGES);
